import { UsageReportResponse } from './../dtos/usage-report-response';
import { UsageReport } from './../views/usage-report';
import {
	IS_NOT_NULL_OR_UNDEFINED,
	IS_NULL_OR_UNDEFINED,
} from './../../utils/commonUtils/validation-utils';
import { DATE_YMD } from './../../utils/date/date-parser';
import { FULL_NAME } from '../../utils';

export const USAGE_REPORT_TABLE = (
	usageReportResponseList: Array<UsageReportResponse> = []
): Array<UsageReport> => {
	let results: Array<UsageReport> = [];
	if (IS_NULL_OR_UNDEFINED(usageReportResponseList) || usageReportResponseList.length == 0) {
		return results;
	}
	usageReportResponseList.map((usageReportResponse) => {
		let row = {} as UsageReport;
		row.userId = usageReportResponse.userId;
		row.userName = FULL_NAME(usageReportResponse.firstName, usageReportResponse.lastName);
		row.totalFeedbackCount = usageReportResponse.totalFeedbackCount || 0;
		row.avgFeedbackCount = usageReportResponse.avgFeedbackCount || 0;
		row.totalSearchCount = usageReportResponse.totalSearchCount || 0;
		row.avgSearchResults = usageReportResponse.avgSearchResults || 0;
		row.lastSearchDate = IS_NOT_NULL_OR_UNDEFINED(usageReportResponse.lastSearchDate)
			? DATE_YMD(usageReportResponse.lastSearchDate)
			: '';
		row.lastCarrierContacted = usageReportResponse.lastCarrierContacted;
		row.noOfCarriersContacted = usageReportResponse.noOfCarriersContacted;
		results.push(row);
	});
	return results;
};
